// removed by extract-text-webpack-plugin
module.exports = {"Toolbar":"Toolbar__Toolbar__2JJW-","Logo":"Toolbar__Logo__1efBD","DesktopOnly":"Toolbar__DesktopOnly__WADUd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Toolbar/Toolbar.css
// module id = 79
// module chunks = 3